import {
    NEW_MENSAGEM_FISCAL_SUCCESS,
    CANCEL_MENSAGEM_FISCAL_RAPIDO,
    CANCEL_MENSAGEM_FISCAL_RAPIDO_SUCCESS,
    TABLE_MENSAGEM_FISCAL_PENDING,
    TABLE_MENSAGEM_FISCAL_SUCCESS,
    TABLE_MENSAGEM_FISCAL_FAILURE,
    LIST_MENSAGEM_FISCAL_PENDING,
    LIST_MENSAGEM_FISCAL_SUCCESS,
    LIST_MENSAGEM_FISCAL_FAILURE,
    FIND_MENSAGEM_FISCAL_PENDING,
    FIND_MENSAGEM_FISCAL_SUCCESS,
    FIND_MENSAGEM_FISCAL_FAILURE,
    DELETE_MENSAGEM_FISCAL_PENDING,
    DELETE_MENSAGEM_FISCAL_SUCCESS,
    DELETE_MENSAGEM_FISCAL_FAILURE,
    CREATE_MENSAGEM_FISCAL_PENDING,
    CREATE_MENSAGEM_FISCAL_SUCCESS,
    CREATE_MENSAGEM_FISCAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function mensagemFiscalReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_MENSAGEM_FISCAL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_MENSAGEM_FISCAL_PENDING:
        case FIND_MENSAGEM_FISCAL_PENDING:
        case DELETE_MENSAGEM_FISCAL_PENDING:
        case CREATE_MENSAGEM_FISCAL_PENDING:
        case TABLE_MENSAGEM_FISCAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_MENSAGEM_FISCAL_RAPIDO:
        case CANCEL_MENSAGEM_FISCAL_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_MENSAGEM_FISCAL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_MENSAGEM_FISCAL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_MENSAGEM_FISCAL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_MENSAGEM_FISCAL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_MENSAGEM_FISCAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_MENSAGEM_FISCAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_MENSAGEM_FISCAL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_MENSAGEM_FISCAL_SUCCESS:
        case CREATE_MENSAGEM_FISCAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_MENSAGEM_FISCAL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { mensagemFiscalReducer };